import React, { useEffect, useState } from 'react';
import { Button, Card, Collapse, Row } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Background from 'components/common/Background';
import corner6 from 'assets/img/illustrations/corner-6.png';
import FinancingForm from './FinancingForm';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { changeToCoin, formatNumber } from 'helpers/utils';
import classNames from 'classnames';
import SoftBadge from 'components/common/SoftBadge';
import useScreenSize from 'hooks/useScreenSize';
import bg2 from 'assets/img/icons/spot-illustrations/corner-2.png';
// import Charging from 'components/common/Charging';

const Financing = () => {
 const { width } = useScreenSize();
 const { control } = useFormContext();
 const { fields, append, remove, update } = useFieldArray({ control, name: 'financings' });

 const [open, setOpen] = useState(false);
 const [financing, setFinancing] = useState({});

 useEffect(() => {
  if (!open) setFinancing({});
  else {
   setTimeout(() => {
    const element = document.getElementById('formFnc');
    if (element) element.scrollIntoView({ block: 'start', behavior: 'smooth' });
   }, 50);
  }
 }, [open]);

 return (
  <>
   <Card className="mb-3">
    <Card.Header className="position-relative" id="listFnc">
     <Flex justifyContent="start" alignItems="center" wrap="nowrap">
      <div className="flex-grow-1 fs--2">
       <h5 className="mb-0 text-primary">Financiaciones</h5>
       <p className="mb-0">Despliega y crea nuevos financiamientos</p>
      </div>
      <div className="ps-3 border-start border-start-2">
       <Button
        variant="falcon-primary"
        type="button"
        className="icon-item icon-item-sm position-relative z-index-2"
        onClick={() => setOpen(!open)}
       >
        <FontAwesomeIcon icon={open ? 'minus' : 'plus'} />
       </Button>
      </div>
     </Flex>
     <Background image={corner6} className="d-none d-md-block bg-card" />
    </Card.Header>

    {fields.map((fnc, index) => {
     const { name, minInitialPay, initialFee, maxInitials, minFeeIni, maxFinancing, minFeeFnc, lateFee, rate, amortize } = fnc;
     return (
      <Card key={index} className={classNames('m-3', { 'mt-0': index })}>
       <Background image={bg2} className="bg-card" />
       <Card.Body className="hover-actions-trigger fs--1">
        <Row className="g-2 d-flex flex-row flex-wrap">
         <Row className="g-2 col-12 col-md-9">
          <div className="d-flex align-items-center col-6">
           <span className="me-3 d-none d-md-block">Financiacion:</span>
           <h6 className="mb-0 text-primary fs--1 display-6">{name}</h6>
          </div>
          <div className="d-flex align-items-center col-6">
           <span className="me-3 d-none d-md-block">Separacion:</span>
           <SoftBadge pill bg="dark">
            {changeToCoin({ amount: minInitialPay, symbol: true, cents: true })} min
            <FontAwesomeIcon icon="caret-up" className="ms-1" />
           </SoftBadge>
          </div>
          <div className="d-flex align-items-center col-6">
           <h6 className="mb-1 me-1 text-primary fs--1 align-self-end display-6">Ini</h6>
           <h1 className="display-5 m-0">{changeToCoin({ amount: initialFee, symbol: true, cents: true, multiply: true })}</h1>
           <div className="flex-1 fs--1 display-6 d-none d-md-block">
            <h5 className="mb-0 ms-2 text-primary fs--2">
             {maxInitials} ctas max
             <FontAwesomeIcon icon="caret-up" className="ms-1" />
            </h5>
            <p className="ms-1 mb-0">${formatNumber(minFeeIni / 100)} cta min</p>
           </div>
          </div>
          <div className="d-flex align-items-center col-6 justify-content-end">
           <h6 className="mb-1 me-1 text-primary fs--1 align-self-end display-6">Fnc</h6>
           <h1 className="display-5 m-0">
            {changeToCoin({ amount: 100 - initialFee, symbol: true, cents: true, multiply: true })}
           </h1>
           <div className="flex-1 fs--1 display-6 d-none d-md-block">
            <h5 className="mb-0 ms-2 text-primary fs--2">
             {maxFinancing} ctas max
             <FontAwesomeIcon icon="caret-up" className="ms-1" />
            </h5>
            <p className="ms-1 mb-0">${formatNumber(minFeeFnc / 100)} cta min</p>
           </div>
          </div>
         </Row>

         <div className="d-flex flex-column align-items-end col-12 col-md-3">
          <h6 className="m-0 text-primary fs--1 d-none d-md-block">Intereses</h6>
          <ul className={classNames('fa-ul ms-2 mt-1 mb-0', { 'list-group list-group-horizontal': width < 426 })}>
           <li className="py-0">
            <h6 className="text-700 fs--2 mb-1">
             <FontAwesomeIcon
              icon={lateFee > 0 ? 'check' : 'ban'}
              className={classNames('fa-li', {
               'text-success': lateFee > 0,
               'text-secondary': lateFee == 0
              })}
             />
             mora
             <SoftBadge pill bg={lateFee > 0 ? 'success' : 'secondary'} className="ms-2">
              {lateFee} mes
              <FontAwesomeIcon icon={lateFee > 0 ? 'caret-up' : 'caret-down'} className="ms-1" />
             </SoftBadge>
            </h6>
           </li>

           <li className="py-0">
            <h6 className="text-700 fs--2 mb-1">
             <FontAwesomeIcon
              icon={rate > 0 ? 'check' : 'ban'}
              className={classNames('fa-li', {
               'text-success': rate > 0,
               'text-secondary': rate == 0
              })}
             />
             tasa
             <SoftBadge pill bg={rate > 0 ? 'success' : 'secondary'} className="ms-2">
              {rate * 100}%
              <FontAwesomeIcon icon={rate > 0 ? 'caret-up' : 'caret-down'} className="ms-1" />
             </SoftBadge>
            </h6>
           </li>

           <li className="py-0">
            <h6 className="text-700 fs--2 mb-1">
             <FontAwesomeIcon
              icon={amortize > 0 ? 'check' : 'ban'}
              className={classNames('fa-li', {
               'text-success': amortize > 0,
               'text-secondary': amortize < 1
              })}
             />
             amortizacion
             <SoftBadge pill bg={amortize > 0 ? 'success' : 'secondary'} className="ms-2">
              {amortize}
              <FontAwesomeIcon icon={amortize > 0 ? 'caret-up' : 'caret-down'} className="ms-1" />
             </SoftBadge>
            </h6>
           </li>
          </ul>
         </div>
        </Row>

        <div className={classNames('end-0 top-0 p-1 p-md-0 hover-actions', { 'translate-middle-y': width > 425 })}>
         <Button
          variant="link"
          type="button"
          className="d-flex align-items-center fs--1 text-700 p-0"
          onClick={() => {
           setOpen(true);
           setFinancing({ ...fnc, index });
          }}
         >
          <FontAwesomeIcon icon="pencil-alt" />
         </Button>

         <Button
          size="sm"
          variant="link"
          type="button"
          className="d-flex align-items-center fs-1 text-700 p-0 ms-3"
          onClick={() => remove(index)}
         >
          <FontAwesomeIcon icon="times-circle" />
         </Button>
        </div>
       </Card.Body>
      </Card>
     );
    })}

    <Collapse in={open}>
     <Card.Body className="pt-0 pt-md-3" id="formFnc">
      <FinancingForm financing={financing} append={append} update={update} fields={fields} setOpen={setOpen} />
     </Card.Body>
    </Collapse>
   </Card>
  </>
 );
};

export default Financing;
